var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLowCarbNotSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.93,
    height: 46.418,
    viewBox: "0 0 31.93 46.418",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2141",
    "data-name": "Group 2141",
    transform: "translate(-224.977 -55.342)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_352",
    "data-name": "Path 352",
    d: "M145.022,86.819a9.429,9.429,0,0,0,2.381,9.5,9.211,9.211,0,0,0,6.662,2.805,9.927,9.927,0,0,0,1.787-.162v7.263a1.11,1.11,0,0,0,2.22,0V98.958a9.942,9.942,0,0,0,1.8.165,9.211,9.211,0,0,0,6.662-2.805,9.429,9.429,0,0,0,2.381-9.5,1.11,1.11,0,0,0-.684-.73,7.9,7.9,0,0,0-1.464-.343,9.431,9.431,0,0,0,2.149-9.258,1.11,1.11,0,0,0-.684-.731,9.553,9.553,0,0,0-5.969.062,9.971,9.971,0,0,0,.277-2.371,9.428,9.428,0,0,0-5.033-8.4,1.109,1.109,0,0,0-1-.033,9.394,9.394,0,0,0-5.1,8.433,9.968,9.968,0,0,0,.278,2.375,9.552,9.552,0,0,0-5.982-.067,1.11,1.11,0,0,0-.684.731,9.432,9.432,0,0,0,2.149,9.258,7.894,7.894,0,0,0-1.464.343A1.111,1.111,0,0,0,145.022,86.819Zm19.945,7.929a7.164,7.164,0,0,1-6.714,1.985,7.2,7.2,0,0,1,1.983-6.717,7.329,7.329,0,0,1,2.5-1.667q.237-.076.477-.168a7.378,7.378,0,0,1,3.73-.151A7.157,7.157,0,0,1,164.967,94.748ZM166.946,77.7a7.157,7.157,0,0,1-1.979,6.718,7.33,7.33,0,0,1-2.5,1.665q-.242.078-.486.172a7.373,7.373,0,0,1-3.733.148,7.452,7.452,0,0,1-.172-1.563c0-.009,0-.019,0-.028a7.027,7.027,0,0,1,1.716-4.647c.163-.163.328-.337.491-.525A7.164,7.164,0,0,1,166.946,77.7Zm-9.975-10.4a7.157,7.157,0,0,1,3.351,6.149,7.08,7.08,0,0,1-1.661,4.672c-.18.18-.348.362-.507.545a7.453,7.453,0,0,1-1.176.935,7.548,7.548,0,0,1-1.358-1.122c-.052-.057-.1-.114-.158-.171a7.081,7.081,0,0,1-1.831-4.858A7.165,7.165,0,0,1,156.971,67.3Zm-9.977,10.4a7.2,7.2,0,0,1,6.71,1.984l.047.049q.146.164.293.314a7.029,7.029,0,0,1,1.808,4.381v.741a7.4,7.4,0,0,1-.163,1.232,7.377,7.377,0,0,1-3.737-.149q-.241-.093-.478-.169a7.33,7.33,0,0,1-2.5-1.666A7.157,7.157,0,0,1,146.994,77.7Zm0,10.331a7.443,7.443,0,0,1,3.814.18q.159.06.317.112a7.277,7.277,0,0,1,2.58,1.692,7.076,7.076,0,0,1,2.148,4.744V95.5a7.4,7.4,0,0,1-.163,1.232,7.323,7.323,0,0,1-8.7-8.7Z",
    transform: "translate(80.371 -9.571)",
    fill: "#1c9d87"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_355",
    "data-name": "Ellipse 355",
    cx: 8.663,
    cy: 8.663,
    r: 8.663,
    transform: "translate(239.58 84.434)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-minus-circle",
    "data-name": "Icon awesome-minus-circle",
    d: "M7.293.563a6.731,6.731,0,1,0,6.731,6.731A6.73,6.73,0,0,0,7.293.563ZM3.711,8.379a.327.327,0,0,1-.326-.326V6.533a.327.327,0,0,1,.326-.326h7.165a.327.327,0,0,1,.326.326v1.52a.327.327,0,0,1-.326.326Z",
    transform: "translate(240.967 85.814)",
    fill: "#1c9d87"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowCarbNotSelected);
export default __webpack_public_path__ + "static/media/lowCarbNotSelected.af966dddf2e1d17e37c0a2e2ce7eea60.svg";
export { ForwardRef as ReactComponent };